import image1 from '../../assets/featurea.png'
import image2 from '../../assets/featureb.png'
import image3 from '../../assets/featurec.png'

export const featureItems = [
    {
        id: 1,
        header: "CodeX Multi-dimensional features",
        textContent: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum doloremque laboriosam earum possimus iure nihil nisi quisquam, tempora facere dolores id, excepturi illum perferendis repellat, culpa sapiente distinctio nam commodi accusamus neque eaque! Eaque ipsam beatae tenetur architecto, nostrum sint impedit dolores nam neque ex placeat voluptatum quos excepturi ipsum.",
        imgUrl: image1,
    },
    {
        id: 2,
        header: "Reliable and fast",
        textContent: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum doloremque laboriosam earum possimus iure nihil nisi quisquam, tempora facere dolores id, excepturi illum perferendis repellat, culpa sapiente distinctio nam commodi accusamus neque eaque! Eaque ipsam beatae tenetur architecto, nostrum sint impedit dolores nam neque ex placeat voluptatum quos excepturi ipsum.",
        imgUrl: image2,
    },
    {
        id: 3,
        header: "Outstanding User-friendly Documentation",
        textContent: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum doloremque laboriosam earum possimus iure nihil nisi quisquam, tempora facere dolores id, excepturi illum perferendis repellat, culpa sapiente distinctio nam commodi accusamus neque eaque! Eaque ipsam beatae tenetur architecto, nostrum sint impedit dolores nam neque ex placeat voluptatum quos excepturi ipsum.",
        imgUrl: image3,
    },
]